<div (click)="util.nativeNavigation(fundraiser?.action)" class="homepage-sip-banner">
  <a [href]="fundraiser?.action" mat-button>
    <span>{{fundraiser?.action_text}}</span>
    <span class="material-icons">chevron_right</span>
  </a>
  <div class="content">
    <div class="title">{{fundraiser?.title}}</div>
    <div class="desc">{{fundraiser?.descr}}</div>
  </div>
  <img loading="lazy" [attr.data-src]="fundraiser?.desktop?.cdn_path" [alt]="fundraiser?.title" default="/assets/images/default-campaign-picture.jpg" />
</div>

<div class="urgent-divider d-block d-lg-none d-md-none d-sm-none"></div>